// @ts-nocheck
/* eslint-disable */
export const llaPlatformBookmarkIcon = {
    data: `<svg viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.75 2.75C0.75 1.64543 1.64543 0.75 2.75 0.75H9.25C10.3546 0.75 11.25 1.64543 11.25 2.75V15.25L6 10.75L0.75 15.25V2.75Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'bookmark' as const
};